const getUrlFromScreenName = (screenName: string) => {
    return screenName?.replace(/(?:_|\s|-)+/g, '-').toLowerCase();
};

export default getUrlFromScreenName;
